var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"align":"center","justify":"center","no-gutters":""}},[(!_vm.stockId)?_c('g-loading'):(!_vm.displayCharts)?_c('generic-stock-detail',{attrs:{"stock-id":_vm.stockId}}):_c('supervisor-stock-detail',{attrs:{"stock-id":_vm.stockId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }